var exports = {
  "kL": "x804f0401--c5a77c--container",
  "DD": "x804f0401--c5a77c--title",
  "h_": "x804f0401--c5a77c--description",
};

module.exports = exports;
